import moment from "moment";
import type { CalendarEventArgs } from "../calendar.types";

/**
 * Creates a Google Calendar URL for adding an event
 *
 * @param args - Calendar event arguments
 * @returns Google Calendar URL that opens the "add event" dialog
 *
 * @example
 * ```typescript
 * const url = createGoogleCalendarUrl({
 *   startDateTime: "2025-03-15T14:00:00Z",
 *   endDateTime: "2025-03-15T15:00:00Z",
 *   eventTitle: "Team Meeting",
 *   eventDescription: "Weekly sync",
 *   eventUrl: "https://example.com/meeting",
 * });
 * window.open(url, "_blank");
 * ```
 */
export function createGoogleCalendarUrl({
  startDateTime,
  endDateTime,
  eventTitle,
  eventDescription,
  eventUrl,
}: CalendarEventArgs): string {
  // Format dates for Google Calendar (YYYYMMDDTHHMMSSZ format)
  const startTime = moment.utc(startDateTime).format("YYYYMMDDTHHmmss") + "Z";
  const endTime = moment.utc(endDateTime).format("YYYYMMDDTHHmmss") + "Z";

  // Create the Google Calendar URL
  const baseUrl = "https://calendar.google.com/calendar/render";

  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: eventTitle,
    dates: `${startTime}/${endTime}`,
    location: eventUrl || "",
    details: eventDescription || "",
  });

  return `${baseUrl}?${params.toString()}`;
}

export default createGoogleCalendarUrl;
